import React, { useEffect, useState } from 'react';
import RowCell from './RowCell';
import { getClassNames } from '../../../utils';
import { Column } from '../utils/types';

export type RowData = {
  key: string | number;
  children?: RowData[];
  [key: string]: any;
  className?: string | undefined;
};

type RowProps = {
  data: RowData;
  index?: number;
  level?: number;
  hidden?: boolean;
  scrollable?: boolean;
  expandedRows?: (string | number)[];
  columns: Column[];
  onRow?: (data: RowData, index: number) => React.HTMLAttributes<HTMLTableRowElement>;
  expandOnClick?: (key: string | number) => void;
  rowClassName?: string;
};

const Row: React.FC<RowProps> = ({
  data,
  index = 0,
  level = 0,
  hidden = false,
  scrollable = false,
  expandedRows = [],
  columns = [],
  onRow = () => ({}),
  expandOnClick = () => {},
  rowClassName,
}) => {
  const [expanded, setExpanded] = useState(expandedRows.includes(data.key));

  const rowProps: React.HTMLAttributes<HTMLTableRowElement> = onRow(data, index) || { className: '' };
  const className = getClassNames(rowClassName, rowProps.className, `row-level-${level}`);

  useEffect(() => {
    setExpanded(expandedRows.includes(data.key));
  }, [expandedRows, data.key]);

  return (
    <>
      <tr role="row" hidden={hidden} {...rowProps} className={className}>
        {columns.map((column, index) => (
          <RowCell
            row={data}
            data={data[column.key]}
            index={index}
            level={level}
            column={column}
            expanded={expanded}
            scrollable={scrollable}
            onExpand={() => expandOnClick(data.key)}
            key={`row-cell-${column.key}`}
          />
        ))}
      </tr>
      {(data.children || []).map((item, ind) => (
        <Row
          data={item}
          index={ind}
          level={level + 1}
          hidden={!expanded}
          columns={columns}
          scrollable={scrollable}
          key={`row-child-${item.key}`}
        />
      ))}
    </>
  );
};

export default Row;
